import {createSelector} from '@reduxjs/toolkit'

const lenderNextStepSelector = createSelector(
    [state => state.primaryAgencyApplication],
    (primaryApplication) => {
        const agencyApplication = primaryApplication?.application
        const companyRjscDetails = agencyApplication?.businessLicenceData?.companyRjscDetails ?? {}
        const userApplicationReviewComplete = agencyApplication?.businessLicenceData?.userApplicationReviewComplete ?? false

        return {
            applicationId : agencyApplication?.id,
            businessLicenceData : agencyApplication?.businessLicenceData ?? {},
            companyRjscDetails,
            agencyApplicationReview : userApplicationReviewComplete,
        }
    }
)

export const lenderNextStepSelect = state => ({
    lenderNextStep : lenderNextStepSelector(state)
})
